import helper from "./helper";
import chart, { helpers } from "chart.js";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

require('./bootstrap');


(function ($) {
    "use strict";

    $(".modal").click(function(){
        $("body").removeClass('overflow-y-hidden modal-open');
    });
    
    if ($("#konsesi-proyek-chart-widget").length) {
    	// console.log(konsesi_proyek);
        let ctx = $("#konsesi-proyek-chart-widget")[0].getContext("2d");
        let myChart = new chart(ctx, {
            type: "bar",
            data: {
                labels: [
                    "0 - 10",
                    "10 - 20",
                    "20 - 30",
                    "30 - 40",
                    "40 - 50",
                ],
                datasets: [
                    {
                        label: "Usercharge",
                        // barPercentage: 0.5,
                        // barThickness: 12,
                        // maxBarThickness: 8,
                        // minBarLength: 4,
                        data: konsesi_proyek[0],
                        backgroundColor: "#203f90",
                    },
                    {
                        label: "AP",
                        // barPercentage: 0.5,
                        // barThickness: 6,
                        // maxBarThickness: 8,
                        // minBarLength: 2,
                        data: konsesi_proyek[1],
                        backgroundColor: "#14B177",
                    },

                ],
            },
            options: {
                scales: {
                    xAxes: [
                        {
                            ticks: {
                                fontSize: "12",
                                fontColor: "#777777",
                            },
                            gridLines: {
                                display: false,
                            },
                        },
                    ],
                    yAxes: [
                        {
                            ticks: {
                                fontSize: "12",
                                fontColor: "#777777",
                                callback: function (value, index, values) {
                                    return  value;
                                },
                            },
                            gridLines: {
                                color: "#D8D8D8",
                                zeroLineColor: "#D8D8D8",
                                borderDash: [2, 2],
                                zeroLineBorderDash: [2, 2],
                                drawBorder: false,
                            },
                        },
                    ],
                },
            },
        });
    }

    if ($("#investment_scheme-proyek-chart-widget").length) {
    	// console.log(konsesi_proyek);
        let ctx = $("#investment_scheme-proyek-chart-widget")[0].getContext("2d");
        let myChart = new chart(ctx, {
            type: "bar",
            data: {
                labels: [
                    "User Charge",
                    "Availibility Payment",
                ],
                datasets: [
                    {
                        label: "Usercharge",
                        // barPercentage: 0.5,
                        // barThickness: 6,
                        // maxBarThickness: 8,
                        // minBarLength: 2,
                        data: investment_scheme[0],
                        backgroundColor: "#203f90",
                    },
                    {
                        label: "AP",
                        // barPercentage: 0.5,
                        // barThickness: 6,
                        // maxBarThickness: 8,
                        // minBarLength: 2,
                        data: investment_scheme[1],
                        backgroundColor: "#14B177",
                    },

                ],
            },
            options: {
                scales: {
                    xAxes: [
                        {
                            ticks: {
                                fontSize: "12",
                                fontColor: "#777777",
                            },
                            gridLines: {
                                display: false,
                            },
                        },
                    ],
                    yAxes: [
                        {
                            ticks: {
                                fontSize: "12",
                                fontColor: "#777777",
                                callback: function (value, index, values) {
                                    return  value;
                                },
                            },
                            gridLines: {
                                color: "#D8D8D8",
                                zeroLineColor: "#D8D8D8",
                                borderDash: [2, 2],
                                zeroLineBorderDash: [2, 2],
                                drawBorder: false,
                            },
                        },
                    ],
                },
            },
        });
    }

    if ($("#gov_assurance-proyek-chart-widget").length) {
    	// console.log(konsesi_proyek);
        let ctx = $("#gov_assurance-proyek-chart-widget")[0].getContext("2d");
        let myChart = new chart(ctx, {
            type: "bar",
            data: {
                labels: [
                    "Tidak",
                    "Iya",
                ],
                datasets: [
                    {
                        label: "Usercharge",
                        // barPercentage: 0.5,
                        // barThickness: 6,
                        // maxBarThickness: 8,
                        // minBarLength: 2,
                        data: gov_assurance[0],
                        backgroundColor: "#203f90",
                    },
                    {
                        label: "AP",
                        // barPercentage: 0.5,
                        // barThickness: 6,
                        // maxBarThickness: 8,
                        // minBarLength: 2,
                        data: gov_assurance[1],
                        backgroundColor: "#14B177",
                    },

                ],
            },
            options: {
                scales: {
                    xAxes: [
                        {
                            ticks: {
                                fontSize: "12",
                                fontColor: "#777777",
                            },
                            gridLines: {
                                display: false,
                            },
                        },
                    ],
                    yAxes: [
                        {
                            ticks: {
                                fontSize: "12",
                                fontColor: "#777777",
                                callback: function (value, index, values) {
                                    return  value;
                                },
                            },
                            gridLines: {
                                color: "#D8D8D8",
                                zeroLineColor: "#D8D8D8",
                                borderDash: [2, 2],
                                zeroLineBorderDash: [2, 2],
                                drawBorder: false,
                            },
                        },
                    ],
                },
            },
        });
    }

    // if ($("#gov_support-proyek-chart-widget").length) {
    // 	// console.log(konsesi_proyek);
    //     let ctx = $("#gov_support-proyek-chart-widget")[0].getContext("2d");
    //     let myChart = new chart(ctx, {
    //         type: "bar",
    //         data: {
    //             labels: [
    //                 "Tidak Ada",
    //                 "Ada",
    //                 "Dalam Proses"
    //             ],
    //             datasets: [
    //                 {
    //                     label: "Solicited",
    //                     // barPercentage: 0.5,
    //                     // barThickness: 6,
    //                     // maxBarThickness: 8,
    //                     // minBarLength: 2,
    //                     // data: gov_support[1],
    //                     backgroundColor: "#203f90",
    //                 },
    //                 {
    //                     label: "Unsolicited",
    //                     // barPercentage: 0.5,
    //                     // barThickness: 6,
    //                     // maxBarThickness: 8,
    //                     // minBarLength: 2,
    //                     // data: gov_support[2],
    //                     backgroundColor: "#14B177",
    //                 },

    //             ],
    //         },
    //         options: {
    //             scales: {
    //                 xAxes: [
    //                     {
    //                         ticks: {
    //                             fontSize: "12",
    //                             fontColor: "#777777",
    //                         },
    //                         gridLines: {
    //                             display: false,
    //                         },
    //                     },
    //                 ],
    //                 yAxes: [
    //                     {
    //                         ticks: {
    //                             fontSize: "12",
    //                             fontColor: "#777777",
    //                             callback: function (value, index, values) {
    //                                 return  value;
    //                             },
    //                         },
    //                         gridLines: {
    //                             color: "#D8D8D8",
    //                             zeroLineColor: "#D8D8D8",
    //                             borderDash: [2, 2],
    //                             zeroLineBorderDash: [2, 2],
    //                             drawBorder: false,
    //                         },
    //                     },
    //                 ],
    //             },
    //         },
    //     });
    // }




    if ($("#usulanProyekSolicited").length) {
        
        new Chart(document.getElementById("usulanProyekSolicited"), {
            type: 'doughnut',
            data: {
            labels: ["Usercharge", "Availibility payment"],
            datasets: [
                {
                label: "Usulan Proyek",
                backgroundColor: ["#656FD7", "#C767DC"],
                data: usulanProyekSolicited
                }
            ]
            },
            options: {
                legend: {
                    display: false
                },
                cutoutPercentage:70
            }
        });
    }

    if ($("#usulanProyekUnsolicited").length) {
        
        new Chart(document.getElementById("usulanProyekUnsolicited"), {
            type: 'doughnut',
            data: {
            labels: ["Usercharge", "Availibility payment"],
            datasets: [
                {
                label: "Usulan Proyek",
                backgroundColor: ["#656FD7", "#C767DC"],
                data: usulanProyekUnsolicited
                }
            ]
            },
            options: {
                legend: {
                    display: false
                },
                cutoutPercentage:70
            }
        });
    }

    if ($("#perencanaanSolicited").length) {
        new Chart(document.getElementById("perencanaanSolicited"), {
            type: 'doughnut',
            data: {
            labels: ["Usercharge", "Availibility Payment"],
            datasets: [
                {
                label: "Usulan Proyek",
                backgroundColor: ["#656FD7", "#C767DC"],
                data: perencanaanSolicited
                }
            ]
            },
            options: {
                legend: {
                    display: false
                },
                cutoutPercentage:70
            }
        });
    }

    if ($("#penyiapanSolicited").length) {
        new Chart(document.getElementById("penyiapanSolicited"), {
            type: 'doughnut',
            data: {
            labels: ["Usercharge", "Availibility Payment"],
            datasets: [
                {
                label: "Usulan Proyek",
                backgroundColor: ["#656FD7", "#C767DC"],
                data: penyiapanSolicited
                }
            ]
            },
            options: {
                legend: {
                    display: false
                },
                cutoutPercentage:70
            }
        });
    }

    if ($("#transaksiSolicited").length) {
        new Chart(document.getElementById("transaksiSolicited"), {
            type: 'doughnut',
            data: {
            labels: ["Usercharge", "Availibility Payment"],
            datasets: [
                {
                label: "Usulan Proyek",
                backgroundColor: ["#656FD7", "#C767DC"],
                data: transaksiSolicited
                }
            ]
            },
            options: {
                legend: {
                    display: false
                },
                cutoutPercentage:70
            }
        });
    }

    // if ($("#perencanaanTransaksiUnsolicited").length) {
    //     new Chart(document.getElementById("perencanaanTransaksiUnsolicited"), {
    //         type: 'doughnut',
    //         data: {
    //         labels: ["Usercharge", "Availibility Payment"],
    //         datasets: [
    //             {
    //             label: "Usulan Proyek",
    //             backgroundColor: ["#656FD7", "#C767DC"],
    //             data: perencanaanTransaksiUnsolicited
    //             }
    //         ]
    //         },
    //         options: {
    //             legend: {
    //                 display: false
    //             },
    //             cutoutPercentage:70
    //         }
    //     });
    // }

    if ($("#konstruksiSolicited").length) {
        new Chart(document.getElementById("konstruksiSolicited"), {
            type: 'doughnut',
            data: {
            labels: ["Usercharge", "Availibility Payment"],
            datasets: [
                {
                label: "Usulan Proyek",
                backgroundColor: ["#9cc7fc", "#fcbe51"],
                data: konstruksiSolicited
                }
            ]
            },
            options: {
                legend: {
                    display: false
                },
                cutoutPercentage:70
            }
        });
    }

    // if ($("#konstruksiUnsolicited").length) {
    //     new Chart(document.getElementById("konstruksiUnsolicited"), {
    //         type: 'doughnut',
    //         data: {
    //         labels: ["Usercharge", "Availibility Payment"],
    //         datasets: [
    //             {
    //             label: "Usulan Proyek",
    //             backgroundColor: ["#9cc7fc", "#fcbe51"],
    //             data: konstruksiUnsolicited
    //             }
    //         ]
    //         },
    //         options: {
    //             legend: {
    //                 display: false
    //             },
    //             cutoutPercentage:70
    //         }
    //     });
    // }

    if ($("#operasiSolicited").length) {
        new Chart(document.getElementById("operasiSolicited"), {
            type: 'doughnut',
            data: {
            labels: ["Usercharge", "Availibility Payment"],
            datasets: [
                {
                label: "Usulan Proyek",
                backgroundColor: ["#9cc7fc", "#fcbe51"],
                data: operasiSolicited
                }
            ]
            },
            options: {
                legend: {
                    display: false
                },
                cutoutPercentage:70
            }
        });
    }

    // if ($("#operasiUnsolicited").length) {
    //     new Chart(document.getElementById("operasiUnsolicited"), {
    //         type: 'doughnut',
    //         data: {
    //         labels: ["Usercharge", "Availibility Payment"],
    //         datasets: [
    //             {
    //             label: "Usulan Proyek",
    //             backgroundColor: ["#9cc7fc", "#fcbe51"],
    //             data: operasiUnsolicited
    //             }
    //         ]
    //         },
    //         options: {
    //             legend: {
    //                 display: false
    //             },
    //             cutoutPercentage:70
    //         }
    //     });
    // }

    if ($("#discontinueSolicited").length) {
        new Chart(document.getElementById("discontinueSolicited"), {
            type: 'doughnut',
            data: {
            labels: ["Usercharge", "Availibility Payment"],
            datasets: [
                {
                label: "Usulan Proyek",
                backgroundColor: ["#9cc7fc", "#fcbe51"],
                data: discontinueSolicited
                }
            ]
            },
            options: {
                legend: {
                    display: false
                },
                cutoutPercentage:70
            }
        });
    }


})($);